export default __webpack_public_path__ + "static/media/Pot2.c9eff55f.svg";